<template>
	<div>
		<v-office-filter :objectsFetched="objectsFetched" :objects="filteredObjects"
			:multiSelectFilters="multiSelectFilters" @setMultiSelectFilter="handleSelectedFilters"
			@setSelectedPlacesLength="handleSelectedPlaces"
			@setSelectedTypesOfBuildingsLength="handleSelectedTypesOfBuildings" @setMinSize="handleMinSize"
			@setMaxSize="handleMaxSize" @setSortingOption="handleSortingOption" :apiKey="this.apiKey" ref="officefilter"></v-office-filter>
		<div class="c-object-listing o-width-limiter--full" style="display: block;">
			<div v-if="isDesktop" class="selected-filters">
				<span v-for="(filter, index) in processedFilters" :key="index" class="badge">
					{{ filter }}
					<button @click="removeBadge(index)">
						<span aria-hidden="true" class="c-icon c-icon--xss">
							<svg>
								<use xlink:href="#icon-close"></use>
							</svg>
						</span>
					</button>
				</span>
			</div>
			<div class="c-office-filter__sorting-container"
				:class="{ 'c-office-filter__sorting-container-mobile': !isDesktop }">
				<div class="c-office-filter__container">
					<div class="c-office-filter__left-item">
						<section class="c-office-filter__hits">
							<h3 class="c-office-filter__hits-heading"><span class="c-office-filter__hits-number">{{
									filteredObjects.length }}</span> Lokaler</h3>
						</section>
					</div>
					<div class="c-office-filter__right-item">
						<span>Sortera på:</span>
						<button class="c-office-filter__sorting-select" id="sorting-select"
							@click="showSortingOptions = !showSortingOptions">
							{{ activeSorting.display }}
							<div aria-hidden="true" class="c-icon c-icon--xs c-office-filter-dropdown__toggle-icon">
								<svg>
									<use :xlink:href="`#icon-select-arrow`"></use>
								</svg>
							</div>
						</button>
						<ul v-if="showSortingOptions" v-click-outside="handleClickOutside"
							class="c-office-filter__sorting-options-dropdown">
							<li class="c-office-filter__sorting-option"
								:class="{ 'c-office-filter__sorting-option--active': option === activeSorting }"
								v-for="(option, index) in sortOptions" :key="index"
								@click="selectSortingOption(option)">
								<div v-if="option === activeSorting" aria-hidden="true"
									class="c-icon c-icon--xs c-office-filter__check-icon">
									<svg>
										<use :xlink:href="`#icon-check`"></use>
									</svg>
								</div>
								{{ option.display }}
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="c-object-listing__inner">
				<div class="c-object-listing__item" v-for="(object, index) in filteredObjects" :key="index">
					<v-object :url="object.url" :image="object.image" :title="object.title" :sizeFrom="object.sizeFrom"
						:sizeTo="object.sizeTo" :adjustedMax="object.adjustedMax" :city="object.city"
						:district="object.district"
						:id="`${object.district.toLowerCase()}-${object.city.toLowerCase()}`" :address="object.address"
						:premiseType="object.premiseType" :features="object.selectedFeatures"
						:overflowFeaturesCount="object.overflowFeaturesCount">
					</v-object>
				</div>
			</div>
			<div class="c-object-listing__loading" v-if="isLoading">
				<div class="c-loading">
					<span class="t-visually-hidden">Laddar...</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import VOfficeFilter from '@/components/filter/VOfficeFilter.vue';
import VObject from '@/components/object/VObject.vue';
import VObjectListingDataProvider from '@/components/object-listing/object-listing-data-provider/VObjectListingDataProvider.vue';
import VFiltersWrapper from '@/components/filters-wrapper/VFiltersWrapper.vue';
import vClickOutside from "v-click-outside";

export default {
	name: 'VObjectListing',
	directives: {
		clickOutside: vClickOutside.directive
	},
	components: {
		VOfficeFilter,
		VObject,
		VObjectListingDataProvider,
		VFiltersWrapper
	},
	props: {
		apiUrl: {
			type: String,
			default: ''
		},
		resetAllText: {
			type: String,
			default: 'Återställ val'
		},
		loadingText: {
			type: String,
			default: 'Laddar objekt'
		},
		apiKey: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			activeSorting: {},
			objectsFetched: false,
			isLoading: true,
			filterData: null,
			showSortingOptions: false,
			sortOptions: [
                {
                    display: 'Adress: A - Ö',
                    value: 1
                },
                {
                    display: 'Adress: Ö - A',
                    value: 2
                },
                {
                    display: 'Senaste objekt',
                    value: 3
                },
                {
                    display: 'Yta: minst',
                    value: 4,
                },
                {
                    display: 'Yta: störst',
                    value: 5
                }
            ],
			selectedFilters: [],
			processedFilters: [],
			selectedPlaces: 0,
			selectedTypesOfBuildings: 0,
			minSize: '',
			maxSize: '',
			isDesktop: true,
			filteredObjects: [],
			data: async () => {
				let data
				await axios
					.get(options.apiUrl + '/wihl-api/Premises',
						// .get(options.apiUrl + '/pages/premises__test.json',
						{
							crossDomain: true
						})
					.then(response => {
						if (response && response.data) {
							data = response.data.data;
						}
					});
				return data
			}
		}
	},

	methods: {
		checkScreenSize() {
            this.isDesktop = window.innerWidth >= 768;
        },
		addBadge(filter) {
			if (filter && !this.selectedFilters.includes(filter)) {
				this.selectedFilters.push(filter);
			}
		},
		removeBadge(index) {
			const removedFilter = this.selectedFilters[index];
			this.selectedFilters.splice(index, 1);
			
			this.$refs.officefilter.handleRemovePlace(removedFilter);
			this.handleSelectedFilters(this.selectedFilters);

		},
		handleSelectedFilters(data) {
			this.selectedFilters = data
			if (this.selectedFilters.length === 0) {
				this.filteredObjects = this.currentObjects
				if (this.minSize !== '') {
					this.filteredObjects = this.filteredObjects.filter(object => object.sizeFrom >= parseInt(this.minSize) || object.sizeTo >= parseInt(this.minSize));
				}
				if (this.maxSize !== '') {
					this.filteredObjects = this.filteredObjects.filter(object => object.sizeTo <= parseInt(this.maxSize) || object.sizeFrom <= parseInt(this.maxSize));
				}
			} else {

				this.filteredObjects = []
				this.currentObjects.forEach(object => {
					if (this.selectedPlaces > 0 && this.selectedTypesOfBuildings > 0) {
						if ((this.selectedFilters.includes(object.district.toLowerCase() + '-' + object.city.toLowerCase()) || (this.selectedFilters.includes(object.city))) && (object.premiseType.some(type => this.selectedFilters.includes(type.toLowerCase())))) {
							this.filteredObjects.push(object)
							if (this.minSize !== '') {
								this.filteredObjects = this.filteredObjects.filter(object => object.sizeFrom >= parseInt(this.minSize) || object.sizeTo >= parseInt(this.minSize));
							}
							if (this.maxSize !== '') {
								this.filteredObjects = this.filteredObjects.filter(object => object.sizeTo <= parseInt(this.maxSize) || object.sizeFrom <= parseInt(this.maxSize));
							}
						}
					} else {
						if (this.selectedFilters.includes(object.district.toLowerCase() + '-' + object.city.toLowerCase()) || (this.selectedFilters.includes(object.city))) {
							this.filteredObjects.push(object)
						}
						if (object.premiseType.some(type => this.selectedFilters.includes(type.toLowerCase()))) {
							this.filteredObjects.push(object)
						}
						if (this.minSize !== '') {
							this.filteredObjects = this.filteredObjects.filter(object => object.sizeFrom >= parseInt(this.minSize) || object.sizeTo >= parseInt(this.minSize));
						}
						if (this.maxSize !== '') {
							this.filteredObjects = this.filteredObjects.filter(object => object.sizeTo <= parseInt(this.maxSize) || object.sizeFrom <= parseInt(this.maxSize));
						}
					}

				})
			}
		},
		handleSelectedPlaces(length) {
			this.selectedPlaces = length
		},
		handleSelectedTypesOfBuildings(length) {
			this.selectedTypesOfBuildings = length
		},
		handleMinSize(size) {
			this.minSize = size
		},
		handleMaxSize(size) {
			this.maxSize = size
		},
		handleSortingOption(option) {
			if (option.value === 1) {
				this.filteredObjects.sort((a, b) => (a.address > b.address) ? 1 : -1)
			} else if (option.value === 2) {
				this.filteredObjects.sort((a, b) => (a.address < b.address) ? 1 : -1)
			} else if (option.value === 3) {
				this.filteredObjects.sort((a, b) => (a.changedDate < b.changedDate) ? 1 : -1)
			} else if (option.value === 4) {
				this.filteredObjects.sort((a, b) => (a.sizeFrom > b.sizeFrom) ? 1 : -1)
			} else if (option.value === 5) {
				this.filteredObjects.sort((a, b) => (a.sizeTo < b.sizeTo) ? 1 : -1)
			}

		},
		selectSortingOption(option) {
			this.activeSorting = option
			this.showSortingOptions = false
		},
		handleClickOutside() {
			if (this.activeFilter === 'plats' && this.isDesktop) {
				this.activeFilter = ''
			} else if (this.activeFilter === 'lokal' && this.isDesktop) {
				this.activeFilter = ''
			} else if (this.activeFilter === 'yta' && this.isDesktop) {
				this.activeFilter = ''
			}

			if (this.showSortingOptions && this.isDesktop) {
				this.showSortingOptions = false
			}

		},
	},

	computed: {
		location() {
			return this.data.premisesFilters.filter(filter => {
				filter.name === 'location'
			})
		}
	},

	computed: mapGetters('objects', {
		currentObjects: 'currentObjects',
		multiSelectFilters: 'multiSelectFilters',
		rangeFilters: 'rangeFilters',
		loading: 'loading',
		filtersApplied: 'filtersApplied',
	}),
	watch: {
		selectedFilters: {
			handler(newVal) {
				this.processedFilters = newVal.map(filter => {
					let cleanedFilter = filter.split('-')[0].trim();
					return cleanedFilter
						.split(' ')
						.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
						.join(' ');
				});
			},
			deep: true
		},
		activeSorting() {
            this.handleSortingOption(this.activeSorting)
        },
	},
	render() {
		if (!this.$scopedSlots.default) {
			return;
		}

		const slotScope = {
			objects: this.objects,
			currentObjects: this.currentObjects,
			countObjects: this.currentObjects.length,
			multiSelectFilters: this.multiSelectFilters,
			setMultiSelectFilter: this.setMultiSelectFilter,
			rangeFilters: this.rangeFilters,
			isLoading: this.loading,
			setRangeFilter: this.setRangeFilter,
			resetAllFilters: this.resetAllFilters,
			filtersApplied: this.filtersApplied
		};

		return this.$scopedSlots.default(slotScope);
	},
	created() {
		this.checkScreenSize();
		this.$store.dispatch('objects/fetchObjects', {
			apiUrl: this.apiUrl
		}).then(() => {
			this.filteredObjects = this.currentObjects
			this.filteredObjects.sort((a, b) => (a.changedDate < b.changedDate) ? 1 : -1)
			this.isLoading = false
		}).then(() => {
			this.objectsFetched = true
		})
	},
	mounted() {
	}
}
</script>
